module.exports = __webpack_public_path__ + "202408221624/img/pic_guide_photo_3@2x.6bc99ece.png";